import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

export default function EmailOAuthCallback() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const queryString = searchParams.toString();
    const suffix = queryString ? `?${queryString}` : "";
    const senderProvider = localStorage.getItem("candidateEmailConnectProvider");
    const inboxProvider = localStorage.getItem("inboxToShortlistProvider");
    const emailImportProvider = localStorage.getItem("emailImportProvider");
    const emailImportReturnPath = localStorage.getItem("emailImportReturnPath");
    const inboxJobId = localStorage.getItem("inboxToShortlistJobId");

    if (inboxProvider || emailImportReturnPath === "inbox-to-shortlist") {
      const params = new URLSearchParams(searchParams);
      if (inboxJobId && !params.get("job_id")) {
        params.set("job_id", inboxJobId);
      }
      navigate(`/inbox-to-shortlist?${params.toString()}`, { replace: true });
      return;
    }

    if (emailImportProvider) {
      navigate(`/candidates${suffix}`, { replace: true });
      return;
    }

    if (senderProvider) {
      navigate(`/profile${suffix ? `${suffix}&section=app_configuration` : "?section=app_configuration"}`, { replace: true });
      return;
    }

    navigate("/profile?section=app_configuration", { replace: true });
  }, [navigate, searchParams]);

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-6">
      <div className="rounded-xl border border-emerald-100 bg-white p-6 text-center shadow-sm">
        <p className="text-sm font-semibold text-emerald-800">Completing email connection...</p>
        <p className="mt-2 text-sm text-slate-500">RecruitGlance is returning you to the correct workflow.</p>
      </div>
    </div>
  );
}
